/**
 * ヤギプライム加入状態の取得。
 *
 * 既存の `is_subscribed/` エンドポイントを、`$varuna`（Vue.prototype）を経由せずに
 * 呼ぶための薄いクライアント（CLAUDE.md: HTTP / API Client Constraints,
 * Infra Plugin Access Constraints）。新規コードは `this.$varuna` を増やさない。
 */
import axios from 'axios'

const ENDPOINT_PREFIX = process.env.VUE_APP_ENDPOINT_PREFIX || '/'

const REQUEST_TIMEOUT_MS = 15000

export type IsSubscribedResponse = {
  is_subscribed?: boolean
  is_cancel?: boolean
}

/**
 * 加入状態を取得する。
 *
 * `is_subscribed/` は **未加入だと 404** を返す（member_subscription が無い、
 * もしくは会員行自体が無い）。これは通信失敗ではなく「加入していない」という
 * 正常な答えなので、404 だけは未加入として確定させる。ここを null に倒すと
 * `usePrimeMembership` が「判定できていない」状態のままになり、
 * キャンペーンの主対象である未加入ユーザーに紹介枠が一切出なくなる。
 *
 * それ以外の失敗（タイムアウト・5xx 等）は本当に判定できていないので null。
 */
export async function fetchIsSubscribed(
  uid: string
): Promise<IsSubscribedResponse | null> {
  try {
    const { data } = await axios.get<IsSubscribedResponse>(
      `${ENDPOINT_PREFIX}is_subscribed/${uid}/`,
      { timeout: REQUEST_TIMEOUT_MS, headers: { Accept: 'application/json' } }
    )
    return data ?? null
  } catch (error) {
    if (
      (error as { response?: { status?: number } })?.response?.status === 404
    ) {
      return { is_subscribed: false, is_cancel: false }
    }
    console.error(error)
    return null
  }
}
